export const apiConstants = {
  url: "/api/document",
  documenttags: "/api/documenttags"
};
